import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricCursor from './metric-cursor-model'
import {
  delete_metricCursor,
  load_metricCursors,
  store_metricCursor,
} from './metricCursor-service'

export const LoadMetricCursorsAsync = createAsyncThunk<any, any>(
  'composer/load/metricCursor',
  async (params: { uid: string }) => {
    return await load_metricCursors(params)
  },
)

export const CreateMetricCursorAsync = createAsyncThunk<any, any>(
  'composer/create/metricCursor',
  async (params: MetricCursor) => {
    return await store_metricCursor(params)
  },
)

export const DeleteMetricCursorAsync = createAsyncThunk<any, any>(
  'composer/delete/metricCursor',
  async (params) => {
    return await delete_metricCursor(params)
  },
)
